import React, { useState } from "react";
import {
  FaDesktop,
  FaMobileAlt,
  FaAndroid,
  FaCheckCircle,
  FaUserTie,
  FaShoppingCart,
  FaGlobe,
} from "react-icons/fa";

import seller_orders_view from '../../../assets/Docs/buyer_orders.png'
import buyer_order_app from '../../../assets/AppImages/Buyer_orders.png'

import { TagComponent } from "../Tabs";


const OrderActions = () => {

  const [activeTab2, setActiveTab2] = useState('web');

  const tabs = [
    { id: 'web', label: 'Web App', icon: <FaDesktop /> },
    { id: 'mobile', label: 'Mobile App', icon: <FaMobileAlt />, disabled: true },
  ];

  const renderTabs = (activeState, setActiveState) => (
    <div className="flex flex-col sm:flex-row gap-2 border-b border-[#b9ece6] sm:gap-4 mb-6">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => setActiveState(tab.id)}
          className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md transition-all text-sm w-full sm:w-auto ${activeState === tab.id
            ? "bg-[#1a9588] text-white shadow"
            : "bg-[#dbf4f1] text-gray-700 hover:bg-[#b9ece6]"
            }`}

        >
          {tab.icon}
          {tab.label}
        </button>
      ))}
    </div>
  );

  return (
    <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">

      <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
        <FaCheckCircle className="text-4xl text-theme-logo-color mr-3" />
        <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color">Order Actions</h1>
      </div>

      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaUserTie />} label="Seller" color="pink" />
          <TagComponent icon={<FaShoppingCart />} label="Buyer" color="green" />
        </div>
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaGlobe />} label="Web" color="green" />
          <TagComponent icon={<FaAndroid />} label="Android" color="green" />
        </div>
      </div>

      <div className="bg-gray-50 p-6 rounded-2xl ">
        <p className="text-gray-700 text-start text-base leading-relaxed ">
          Each 'Buyer' on Selzor receives three separate Order Carts. This
          allows buyers to transfer items between carts and quickly finalise the
          one containing the most urgent items, while the other carts hold less
          time-sensitive products.
        </p>
      </div>

      {/* Intro Text */}
      <div className="text-start mx-auto p-6 bg-white rounded-2xl shadow border border-gray-200">
        {/* Header */}
        <h2 className="text-xl font-semibold mb-4">Order Actions</h2>

        {/* Description */}
        <p className="text-gray-700 mb-4">
          Order Actions enable you to perform certain actions and/or bulk
          actions on the selected order(s). These actions include:
        </p>

        {/* Action List */}
        <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
          <li>Edit, Complete or Cancel the selected order</li>
          <li>
            Change Order Status to 'Confirmed', In-Process' or 'On-Hold' for all
            the selected orders
          </li>
          <li>Export selected orders in JSON or XML format</li>
        </ul>

        {/* Note */}
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 text-yellow-800 text-sm rounded">
          Only 1 (one) order can be edited, completed or cancelled. Bulk edit,
          complete & cancel is not available.
        </div>
      </div>


      <div className="my-5">
        {renderTabs(activeTab2, setActiveTab2)}
        <div className="rounded-xl p-4 sm:p-6  bg-gray-50 border border-gray-200 shadow-sm hover:shadow-md transition">
          {activeTab2 === "web" ? (
            <img
              src={seller_orders_view}
              alt={`view`}
              className="rounded-xl max-w-full h-auto object-contain"
            />
          ) : (
            <img
              src={buyer_order_app}
              alt={`view`}
              className="rounded-xl max-w-full h-auto object-contain"
            />
          )}

          <p className="mt-6 text-gray-500 text-sm ">
            Tap 'Add New Order' to create a new order. Buyers will see their list of 'Suppliers,' while Suppliers (Sellers) will see their list of 'Buyers.' Choose the appropriate contact to place a new order for that supplier or buyer.
          </p>
        </div>
      </div>

    </div>
  );
};

export default OrderActions;
